import React, { useState } from "react";
import axios, { post } from "axios";
import { Box, Typography, Grid, Container, Button } from "@mui/material";

import EnhancedTable from "./BudgetTable";

import { Alert, CircularProgress } from "@mui/material";
import BudgetTable from "./BudgetTable";
import { API_BASE } from "utils/api";
const BudgetUpload = () => {
  const [uploadFile, setUploadFile] = React.useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [alert, setAlert] = useState(false);
  const [uploadResponse, setUploadResponse] = React.useState();
  const [budget, setBudget] = React.useState();
  const submitForm = (event) => {
    setIsLoaded(true);

    event.preventDefault();

    const dataArray = new FormData();

    dataArray.append("uploadFile", uploadFile);

    axios
      .post(`${API_BASE}/importStoresBudget/`, dataArray, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setUploadResponse("File uploaded successfully");
        setIsLoaded(false);
        setAlert(true);
      })
      .catch((error) => {
        setUploadResponse("Error in uploading file");
        setIsLoaded(false);
        setAlert(true);
      });
  };

  const onChange1 = (e) => {
    setUploadFile(e.target.files[0]);
  };
  return (
    <Container maxWidth={false}>
      <form onSubmit={submitForm}>
        <Box pl={3} pt={3}>
          <Typography color="primary" gutterBottom variant="h6">
            Budget file upload
          </Typography>
          <Box pt={4}>
            <Grid item md={3} xs={3}>
              <input type="file" onChange={onChange1} />
              <button type="submit" variant="contained" color="primary">
                Upload
              </button>
            </Grid>
          </Box>
        </Box>
        <Box pt={4} pl={2}>
          <Grid item md={3} xs={3}>
            {isLoaded && <CircularProgress color="secondary" />}
            {alert && <Alert severity="info"> {uploadResponse} </Alert>}
          </Grid>
        </Box>
      </form>
    </Container>
  );
};
export default BudgetUpload;
